import Vue from 'vue';
import Vuex, {ActionContext, Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {EssenceAchat, BoisType, LongueursAchat, Achat, Livraison} from '@/models';
import {EssenceAchatService} from "@/xhttp";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';
import {storeLivraisonsTotaux} from "@/stores/modules/livraison";

Vue.use(Vuex);

export class EssenceAchatFilter {

	boisType: BoisType[] = [];
	longueursAchat: LongueursAchat[] = [];
	volumeAchat: string = '';
	volumeRestant: string = '';
	prixStere: string = '';
	achat: Achat[] = [];
	finCoupe: string = '';
	paye: string = '';
	totalParBoisType: boolean = false;
	totalParLongueur: boolean = false;
	achatLocalisation: string = '';
	boisTypeSearch: BoisType = null;
	longueurSearch: LongueursAchat = null;


	public clear(): void {
		this.boisType = [];
		this.longueursAchat = [];
		this.volumeAchat = '';
		this.volumeRestant = '';
		this.prixStere = '';
		this.achat = [];
		this.finCoupe = '';
		this.paye = '';
		this.totalParBoisType = false;
		this.totalParLongueur = false;
		this.achatLocalisation = '';
	}

	public toString(): string {
		return JSON.stringify({
			boisType    : this.boisType.map(t => t.id),
			longueursAchat    : this.longueursAchat.map(t => t.id),
			volumeAchat: this.volumeAchat,
			volumeRestant : this.volumeRestant,
			achat    : this.achat.map(t => t.id),
			totalParBoisType	: this.totalParBoisType,
			totalParLongueur	: this.totalParLongueur,
		});

	}
}

class EssenceAchatState extends PaginatorFilterState<EssenceAchatFilter> {
	essenceAchat: EssenceAchat = null;
	essenceAchats: ResultType<EssenceAchat> = null;
	public constructor() {
		super(new EssenceAchatFilter(), 'essenceAchats', 'essenceAchat', 'id', AscDesc.DESC, 20)
	}
}

class EssenceAchatStore {

	@XHTTPService(() => EssenceAchat)
	private essenceAchatService: EssenceAchatService;
	private  _store: Store<any>;

	public state: EssenceAchatState = new EssenceAchatState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'essenceAchats', 'essenceAchat'),
	};

	public actions = {
		...StandardAction<EssenceAchat, EssenceAchatState>(() => EssenceAchat, 'essenceAchat'),
		...PaginatorActionWithFilters<EssenceAchat, EssenceAchatState>(() => EssenceAchat, 'essenceAchats', 'essenceAchat'),

		async getTotauxEssenceAchats(context: ActionContext<EssenceAchatState, any>): Promise<ResultType<EssenceAchat>> {
			const essenceAchatsTotauxResult = await instance.essenceAchatService.getTotauxEssenceAchats(storeEssenceAchatsTotaux.state.filters.totalParBoisType, storeEssenceAchatsTotaux.state.filters.totalParLongueur);
			context.commit('setEssenceAchats', essenceAchatsTotauxResult);
			return essenceAchatsTotauxResult;
		},

		async getRechercheEssenceAchats(context: ActionContext<EssenceAchatState, any>): Promise<ResultType<EssenceAchat>> {
			const essenceAchatsRechercheResult = await instance.essenceAchatService.getRechercheEssenceAchats(storeEssenceAchatsRecherche.state.filters.boisTypeSearch, storeEssenceAchatsRecherche.state.filters.longueurSearch, storeEssenceAchatsRecherche.state.filters.achatLocalisation ? storeEssenceAchatsRecherche.state.filters.achatLocalisation : '' );
			context.commit('setEssenceAchats', essenceAchatsRechercheResult);
			return essenceAchatsRechercheResult;
		},

		async putFinCoupe(context: ActionContext<EssenceAchatState, any>, essenceAchat: EssenceAchat) {
			const essence = await instance.essenceAchatService.putFinCoupe(essenceAchat)
			return essence;
		},
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new EssenceAchatStore();
const storeEssenceAchat = new Vuex.Store(instance);
instance.init(storeEssenceAchat);

const instanceTotaux = new EssenceAchatStore();
export const storeEssenceAchatsTotaux = new Vuex.Store(instanceTotaux);
instanceTotaux.init(storeEssenceAchatsTotaux);

const instanceRecherche = new EssenceAchatStore();
export const storeEssenceAchatsRecherche = new Vuex.Store(instanceRecherche);
instanceTotaux.init(storeEssenceAchatsRecherche);

store.registerModule('essenceAchat', storeEssenceAchat);
store.registerModule('essenceAchatTotaux', storeEssenceAchatsTotaux);
store.registerModule('essenceAchatRecherche', storeEssenceAchatsRecherche);
export default storeEssenceAchat;